//#region src/engine/modules/editor/actions.ts
var ActionType = {
	changeHasHistory: "editor.changeHasHistory",
	selectAll: "editor.selectAll",
	unselectAll: "editor.unselectAll",
	select: "editor.select",
	changeViewport: "editor.changeViewport",
	clear: "editor.clear",
	loadJson: "editor.loadJson",
	initialClear: "editor.initialClear",
	initialLoadJson: "editor.initialLoadJson",
	focusTable: "editor.focusTable",
	focusColumn: "editor.focusColumn",
	focusTableEnd: "editor.focusTableEnd",
	focusMoveTable: "editor.focusMoveTable",
	editTable: "editor.editTable",
	editTableEnd: "editor.editTableEnd",
	editMemo: "editor.editMemo",
	editMemoEnd: "editor.editMemoEnd",
	editTableGroup: "editor.editTableGroup",
	editTableGroupEnd: "editor.editTableGroupEnd",
	scrollMemo: "editor.scrollMemo",
	selectAllColumn: "editor.selectAllColumn",
	drawStartRelationship: "editor.drawStartRelationship",
	drawStartAddRelationship: "editor.drawStartAddRelationship",
	drawEndRelationship: "editor.drawEndRelationship",
	drawRelationship: "editor.drawRelationship",
	hoverColumnMap: "editor.hoverColumnMap",
	hoverRelationshipMap: "editor.hoverRelationshipMap",
	changeOpenMap: "editor.changeOpenMap",
	changeHandTool: "editor.changeHandTool",
	changeDrawTableGroup: "editor.changeDrawTableGroup",
	changeZenMode: "editor.changeZenMode",
	dragstartColumn: "editor.dragstartColumn",
	dragendColumn: "editor.dragendColumn",
	sharedMouseTracker: "editor.sharedMouseTracker",
	sharedFocusTracker: "editor.sharedFocusTracker",
	sharedSelectionTracker: "editor.sharedSelectionTracker",
	sharedDragSelectTracker: "editor.sharedDragSelectTracker",
	dragSelectRect: "editor.dragSelectRect",
	getLWW: "editor.getLWW",
	mergeLWW: "editor.mergeLWW",
	viewOpen: "editor.viewOpen",
	viewClose: "editor.viewClose",
	viewScrollTo: "editor.viewScrollTo",
	viewStreamScrollTo: "editor.viewStreamScrollTo",
	viewChangeZoomLevel: "editor.viewChangeZoomLevel",
	viewStreamZoomLevel: "editor.viewStreamZoomLevel",
	viewMoveTable: "editor.viewMoveTable",
	viewSetLayout: "editor.viewSetLayout",
	viewChangeShowMode: "editor.viewChangeShowMode",
	viewSetCenters: "editor.viewSetCenters",
	viewStepCenters: "editor.viewStepCenters",
	changeVisualizationMode: "editor.changeVisualizationMode",
	endScreenSettings: "editor.endScreenSettings"
};
//#endregion
export { ActionType };
